import { commonPost, fieldsGet, commonGet } from '@/utils/request.js';

export const login = data => commonPost('/api/user/login', data);

export const CommonExportGetApi = (url, data) => fieldsGet(`/api${url}`, data);

export const updatePasswordApi = data => commonPost('/api/user/updatePassword', data);

export const getOpenId = data => commonGet('/api/user/getOpenId', data);

// export const fileUpload = data => commonPost('/api/file/upload', data);